import { Grid } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const LoadingIndicator: React.FC<{ size?: string }> = ({ size = '1.6rem' }) => {
  return (
    <Grid container justifyContent={'center'} my={1}>
      <CircularProgress size={size} color="secondary" />
    </Grid>
  );
};
export default LoadingIndicator;
